import React from 'react';

interface PaginationProps {
  offset: number;
  pageSize: number;
  hasMore: boolean;
  onPageChange: (newOffset: number) => void;
  className?: string;
}

const Pagination: React.FC<PaginationProps> = ({ offset, pageSize, hasMore, onPageChange, className = '' }) => {
  return (
    <div className={`mt-4 flex justify-between ${className}`}>
      <button
        className="rounded-xl border border-[color:var(--wf-plum-deep)]/60 bg-[linear-gradient(135deg,rgba(67,48,63,1),rgba(95,70,92,1))] px-4 py-2 text-white shadow-[0_10px_30px_rgba(67,48,63,0.18)] transition-all duration-200 hover:-translate-y-0.5 disabled:opacity-50"
        onClick={() => onPageChange(Math.max(0, offset - pageSize))}
        disabled={offset === 0}
      >
        Previous
      </button>
      <button
        className="rounded-xl border border-[color:var(--wf-plum-deep)]/60 bg-[linear-gradient(135deg,rgba(67,48,63,1),rgba(95,70,92,1))] px-4 py-2 text-white shadow-[0_10px_30px_rgba(67,48,63,0.18)] transition-all duration-200 hover:-translate-y-0.5 disabled:opacity-50"
        onClick={() => onPageChange(offset + pageSize)}
        disabled={!hasMore}
      >
        Next
      </button>
    </div>
  );
};

export default Pagination; 
